import DealHelper from "@js/helpers/DealHelper";
import { ODataHelper } from "@js/helpers/ODataHelper";
import {
  ApplicationUserCrudClient,
  BrickflowEventLogClient,
  BridgingDeal,
  Client,
  CommercialDeal,
  DealClient,
  DevelopmentFinanceDeal,
  LocationEnum,
  OrganisationLinkClient,
  ShareDealDTO,
  UserClient,
  UserIdEmailPairDTO,
} from "@src/apis/ModularClient";
import { SharedCriteriaService } from "@js/services/Deal/SharedCriteriaService";

export class CriteriaController<T extends BridgingDeal | CommercialDeal | DevelopmentFinanceDeal> {
  dealDto: T;
  dataLoading: boolean = false;

  //Postcode properties
  showPostcodeErrorMessage: boolean = false;
  postcodeErrorMsg: string;
  previouslySelectedLocation: LocationEnum;

  orgLinkId: number = null;

  shareDealDto: ShareDealDTO = {
    isApplicant: true,
    isPrimary: true,
  } as ShareDealDTO;
  existingUsers: UserIdEmailPairDTO[] = [];
  showClientDetails: boolean = false;
  selectedBorrowerId: number;

  //VATBridging
  showVATBridgingModal: boolean = false;
  getQuoteForm: ng.IFormController;
  acceptTerms: boolean;
  quoteRequestSuccessMessage: string;
  quoteRequestFailureMessage: string;
  static $inject = [
    "DealClient",
    "$routeParams",
    "ODataHelper",
    "OrganisationLinkCrudClient",
    "SharedCriteriaService",
    "ApplicationUserCrudClient",
    "UserClient",
    "BrickflowEventLogClient",
  ];

  constructor(
    public dealService: DealClient,
    public $routeParams: ng.route.IRouteParamsService,
    public odataHelper: ODataHelper,
    public organisationLinkClient: OrganisationLinkClient,
    public sharedCriteriaService: SharedCriteriaService,
    public applicationUserCrudClient: ApplicationUserCrudClient,
    public userClient: UserClient,
    public eventLogClient: BrickflowEventLogClient,
  ) {}

  getRegionByPostcode() {
    if (this.dealDto.postcodeSearchString && this.dealDto.postcodeSearchString.replace(" ", "").length >= 2) {
      if (DealHelper.isValidPostcodeString(this.dealDto.postcodeSearchString)) {
        this.dataLoading = true;
        this.dealService
          .getRegionByPostcode(this.dealDto.postcodeSearchString)
          .then((response) => {
            if (response.location != null) {
              this.dealDto.locations = response.location;
              this.showPostcodeErrorMessage = false;
            } else {
              this.postcodeErrorMsg = response.postCodeErrorMessage;
              this.showPostcodeErrorMessage = true;
              if (this.dealDto.locations) this.dealDto.locations = null;
            }
          })
          .finally(() => {
            this.dataLoading = false;
          });
      } else {
        this.postcodeErrorMsg = "At least one letter and one number must be entered e.g. SW1.";
        this.showPostcodeErrorMessage = true;
        if (this.dealDto.locations) this.dealDto.locations = null;
      }
    } else {
      if (this.dealDto.locations) this.dealDto.locations = null;
    }
  }

  onHasPostcodeChange() {
    if (!this.dealDto.hasPostcode) {
      this.showPostcodeErrorMessage = false;
      this.dealDto.postcodeSearchString = null;
      this.dealDto.locations = this.previouslySelectedLocation;
    } else {
      this.previouslySelectedLocation = this.dealDto.locations;
      this.dealDto.locations = null;
    }
  }

  async getProductFamiliesByUniqueId() {
    const response = await this.organisationLinkClient.getOrganisarionlinkUniqueId(this.$routeParams.uniqueId);
    this.orgLinkId = response.id;
  }

  viewClientsDashboardForNewSearch(id: number) {
    this.odataHelper
      .getOne(this.applicationUserCrudClient, {
        filter: { id: { eq: id } },
        select: {
          id: true,
          email: true,
          firstName: true,
          lastName: true,
          phoneNumber: true,
        },
      })
      .then((user) => {
        const clientDto: Client = {
          firstName: user.firstName,
          email: user.email,
          lastName: user.lastName,
          phoneNumber: user.phoneNumber,
          clientUserId: user.id,
        } as Client;
        this.shareDealDto.clientDto = clientDto;

        this.shareDealDto.isApplicant = true;
        this.shareDealDto.isPrimary = true;

        this.showClientDetails = true;
      });
  }

  sendVATBridgingLeadEmail() {
    this.dataLoading = true;
    this.userClient
      .sendVATBridgingLeadEmail(this.dealDto.purchasePrice, true)
      .then(() => {
        this.quoteRequestSuccessMessage = "Quote requested!";
        this.acceptTerms = false;
      })
      .catch(() => {
        this.quoteRequestFailureMessage = "Error while requesting a quote. Please try again later.";
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  closeVATBridgingModal() {
    this.showVATBridgingModal = false;
    this.acceptTerms = false;
    this.quoteRequestSuccessMessage = "";
    this.quoteRequestFailureMessage = "";
  }
}
